<template>
  <div v-loading="listLoading" element-loading-text="拼命加载中...">
    <!-- <div class="breadcrumb">
              <el-breadcrumb separator-class="el-icon-arrow-right" class="systemTag">
              </el-breadcrumb>
          </div> -->
    <div class="filter" style="margin-top: -30px">
      <el-tabs type="border-card" class="card-tab">
        <el-tab-pane label="协议授权配置">
          <el-form
            :model="param"
            :inline="true"
            label-width="125px"
            class="formInline"
            size="mini"
          >
            <div class="slide-wrap" ref="slideWrap1">
              <el-form-item label="项目编号">
                <el-input
                  v-model="param.projectCode"
                  placeholder="请输入..."
                  :maxlength="80"
                ></el-input>
              </el-form-item>
              <el-form-item label="项目名称">
                <el-input
                  v-model="param.projectName"
                  placeholder="请输入..."
                  :maxlength="80"
                ></el-input>
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px" />
            <div class="slide-btns clearfix">
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetForm()"
                  >清空</el-button
                >
                <el-button class="search-btn" @click="submitForm()"
                  >筛选</el-button
                >
              </el-form-item>
              <div class="floatr">
                <el-form-item>
                  <!-- v-if="showSlideBtn()" -->
                  <el-button
                    type="text"
                    class="slide-btn"
                    @click="toggleSlide('slideWrap1', $event)"
                    >展开筛选项</el-button
                  >
                </el-form-item>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <div class="tableBody">
        <div class="title">筛选结果</div>
        <el-table
          class="limitManagerTable table-expand"
          style="width: 100%"
          :data="tableData"
          size="small"
          border
          header-row-class-name="table-header"
        >
          <el-table-column
            fixed="left"
            width="100"
            type="index"
            label="#"
            align="center"
          ></el-table-column>
          <el-table-column
          style="width: 30%"
            prop="title"
            label="协议名称"
            align="center"
          >
          <template slot-scope="scope">
              <span  style="color: #1652ff; cursor: pointer;" @click="handleAgreeContent(scope.row)">{{ scope.row.title }}</span>
            </template>
         
        </el-table-column>
          <el-table-column
          style="width: 30%"
            prop="count"
            label="关联项目"
            align="center"
          >
            <template slot-scope="scope">
              <span
                style="
                  cursor: pointer;
                  color: #18a7ff;
                  text-decoration: underline;
                "
                @click="handleProject(scope.row)"
              >
                {{ scope.row.count }}
              </span>
            </template>
          </el-table-column>

          
          <el-table-column
          
            label="操作"
            style="width: 30%"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleProject(scope.row)"
                ><span style="color: #66cc33">编辑</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formData.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="formData.pageSize"
          layout="slot,sizes, total,  prev, pager, next, jumper"
          :total="formData.total"
        >
        </el-pagination>
      </div>
    </div>
    <Project ref="Project" @done="getData" />
    <!-- 客户维护弹窗 -->
    <el-dialog
      :title="handleItem ? handleItem[1] : '错误当前无操作对象'"
      class="quitDialog dialog Qhr_contract"
      width="480px"
      :show-close="true"
      :visible.sync="customer"
      top="27vh"
      center
    >
      <el-form label-width="140px">
        <el-form-item label="对应项目客户：" style="margin: 20px 0">
          <el-select
            v-model="customerValue"
            filterable
            :filterMethod="
              (val) => {
                $store.state.funciton.filter(
                  val,
                  this,
                  'allCustomer',
                  'keepAllCustomer'
                );
              }
            "
            @visible-change="
              () => {
                $store.state.funciton.filter(
                  '',
                  this,
                  'allCustomer',
                  'keepAllCustomer'
                );
              }
            "
            placeholder="请选择..."
            @change="disabledSubCustomer = false"
          >
            <el-option
              :label="item[1]"
              :value="item"
              v-for="item in allCustomer"
              :key="item[0]"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customer = false" size="small">取 消</el-button>
        <el-button
          @click="subCustomer()"
          type="primary"
          :disabled="disabledSubCustomer"
          size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog class="blacklistDialog dialog" :title= this.title :visible.sync="authorizeDialog"
               width="1030px" center>
      <div style="font-size: 15px;padding: 10px;text-align: left;">
        <div style="">
          <h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">{{this.title}}</h3>
        </div>
        <div style="overflow-y: scroll;max-height: 400px;">
          <span style="white-space: pre-line;padding: 0 5px;">
            {{this.content}}
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import utils from "../../../common/js/util.js";
import Project from "./Project.vue";
import moment from "moment";
export default {
  components: { Project },
  watch: {},
  data() {
    return {
      //筛选项参数
      param: {},
      param2: {}, //点击筛选之后param才赋值给param2
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null,
      },
      zhangTaoList: [], //账套数组
      allClientId: [], //合同下拉列表数组
      allCustomer: [], //项目客户下拉
      keepAllCustomer: [], //项目客户下拉 存储
      customer: false, //客户维护模态框
      customerValue: "", ///客户维护模态框 内的值
      disabledSubCustomer: true, //禁用提交按钮
      handleItem: {}, //当前操作对象
      tableData: [], //表单信息
      listLoading: false,
      authorizeDialog:false,
      title:"",
      content:""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    //获取数据
    getData() {
      this.listLoading = true;
      let params = {
        ...this.param2,
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo,
      };
      //获取表单数据
      this.$http({
        method: "GET",
        // headers: { "content-type": "application/json" },
        url: "/rest/agreementProject/listAgreement",
        // data: params,
        params: params,
      })
        .then((res) => {
         
          this.tableData = res.data.items;
          this.formData.total = res.data.totalItemsCount;
          this.listLoading = false;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
   
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },
    //提交表单（筛选功能）
    submitForm() {
      this.param2 = JSON.parse(JSON.stringify(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },
    //重置表单（清除筛选项）
    resetForm() {
      this.param = {};
      this.param2 = {};
      this.getData();
    },

    //展开收起
    toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },
    //翻页
    handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },
    //项目维护
    handleProject(item) {
      this.$refs.Project.show(item);
    },
    //协议内容详情
    handleAgreeContent(item) {
      console.log("title:" + item.title)
     this.authorizeDialog = true;
     this.title = item.title;
     this.content = item.content;
    },
  },
};
</script>
  
  <style scoped>
.cutLine {
  border-right: 1px solid #82bc82;
  margin: 0 10px;
  position: relative;
  right: 1px;
}

.tableBody {
  background-color: white;
  margin-top: 15px;
  padding: 20px;
}

.title {
  color: #2e2b78;
  margin-bottom: 20px;
  font-weight: 900;
}
</style>
  <style  >
.Qhr_contract .el-dialog__header {
  text-indent: 2em;
}
</style>
  


// WEBPACK FOOTER //
// src/views/configCanage/agreeProject/AgreeProject.vue